import { motion } from 'framer-motion';
import * as S from './Implementation.style';
import mockup from '../../Assets/macbook_mockup.png';

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0 },
};

export const Implementation = () => {
  const steps = [
    'Diagnóstico inicial gratuito.',
    'Personalização da solução.',
    'Treinamento e implementação.',
    'Suporte contínuo e atualizações.',
  ];

  return (
    <S.Wrapper id="Implementation">
      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        className='lg:w-[50%]'
      >
        <S.Title as={motion.h1} variants={item}>
          Implementação Fácil e Rápida
        </S.Title>

        <S.SubTitle as={motion.p} variants={item}>
          Transforme sua operação em <span className="font-bold">4 passos simples</span>
        </S.SubTitle>

        <S.Text as={motion.ol}>
          {steps.map((step, index) => (
            <motion.li key={index} variants={item} className="mb-2">
              {step}
            </motion.li>
          ))}
        </S.Text>

        <S.Btn
          as={motion.button}
          variants={item}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          comece agora
        </S.Btn>
      </motion.div>

      <motion.img
        src={mockup}
        alt="mockup"
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6 }}
        className="hidden lg:block w-full md:h-[436px] md:min-h-[436px] md:w-[802px] md:min-w-[802px] md:-mr-[200px] lg:-mr-[800x] mt-10 md:mt-0 xl:mr-0"
      />
    </S.Wrapper>
  );
};
